/**
 * @author Ali Hussain
 * @createdOn May, 2025
 * Show animated table for dashboard
 */

import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import "./Marquee.css";
import WhiteObjectApi from "../../api/WhiteObjectApi";

const ProductWiseTotalSQFT = () => {
  const containerRef = useRef(null);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [animationDuration, setAnimationDuration] = useState(0);
  const [body, setBody] = useState(null); // null to detect loading
  const [stopAnimation, setStopAnimation] = useState(false);
  useEffect(() => {
    init();
  }, []);

  async function init() {
    const admissions = await WhiteObjectApi.fetchProductWiseTotalSQFT();
    if (admissions?.length > 0) {
      setBody([...admissions, ...admissions]);
    } else {
      setBody([]);
    }
  }

  useEffect(() => {
    if (!containerRef.current || !body || body.length === 0) return;

    // Measure the component height and translate accordingly as well se decide it's duration
    const measureHeight = () => {
      const fullHeight = containerRef.current?.scrollHeight || 0;
      setScrollHeight(fullHeight / 2);

      const speed = 0.01;
      setAnimationDuration((fullHeight / 2) / speed);
    };

    measureHeight();

    const resizeObserver = new ResizeObserver(() => {
      measureHeight();
    });

    resizeObserver.observe(containerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [body]);
  return (
    <div>
      <Row className="g-0">
        <Col lg={12} className="p-lg-4">
          {body === null ? (
            <ShimmerTable row={10} col={8} />
          ) : (
            <div className="scroll-wrapper">
              {/* Fixed header */}
              <div className="table-row header">
                {body?.at(0) && Object.keys(body?.at(0)).map((value, index) => <div className="cell" key={index}>{value}</div>)}
              </div>

              {/* Scroll container */}
              <div
                onMouseEnter={() => setStopAnimation(true)}
                onMouseLeave={() => setStopAnimation(false)}
                className="scroll-content"
                ref={containerRef}
                style={{
                  animation: (animationDuration)
                    ? `scrollTopToBottom ${animationDuration}ms linear infinite`
                    : "none",
                  transform: `translateY(-${scrollHeight}px)`,
                  animationPlayState: stopAnimation ? "paused" : "running",
                }}
              >
                {body.map((item, i) => (
                  <div className="table-row" key={i}>
                    <div className="cell">{item['PRODUCT NAME']}</div>
                    <div className="cell">{item['TOTAL SQFT (SIRF)']}</div>
                    <div className="cell">{item['CREATED DATE (SQFT)']}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductWiseTotalSQFT;
